// extracted by mini-css-extract-plugin
module.exports = {"dataRow":"DetailsListDataRow_dataRow__MOu3i","dataRowLabel":"DetailsListDataRow_dataRowLabel__3yWSq","dataRowContent":"DetailsListDataRow_dataRowContent__1O-OC"};